import axios from 'axios'
import { adaptLocaleToServer } from '@/helpers/adaptLocaleToServer'
import { useAuthStore } from '@/store/auth'
import { useMainStore } from '@/store/main'

axios.interceptors.request.use((config) => {
  if (config && config.headers) {
    config.baseURL = import.meta.env.VITE_API_BASE_URL
    const mainStore = useMainStore()
    config.headers.Language = adaptLocaleToServer(mainStore.appLocale)
    const authStore = useAuthStore()
    if (authStore.isAuth) {
      config.headers.Authorization = `${authStore.tokenType} ${authStore.token}`
    }
  }
  return config
})

axios.interceptors.response.use(undefined, async (error) => {
  const originalRequest = error.config

  if (!axios.isCancel(error) && [401].includes(error?.response?.status) && !originalRequest._retry) {
    const authStore = useAuthStore()
    originalRequest._retry = true
    if (authStore.isAuth) {
      try {
        await authStore.refreshToken()
        return axios(originalRequest)
      }
      catch (refreshError) {
        authStore.logout()
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }
  }
  return Promise.reject(error)
})
